export default "__VITE_ASSET__BoixTByF__"